import type { ToastServiceMethods } from 'primevue/toastservice';
import useEventsBus from '../composables/useEventsBus';
import i18n from '../config/i18n';
import type { APIResp } from '../types/APIService';

function mapErrorMsg(errMsg: string) {
  if (errMsg.includes('User does not exist')) {
    return i18n.global.t('errors.noUser');
  }
  else if (errMsg.includes('Invalid password or email')) {
    return i18n.global.t('errors.invalidLogin');
  }
  else if (errMsg.includes('Forbidden')) {
    return i18n.global.t('errors.forbidden');
  }
  return errMsg;
};

function getError(resp: APIResp<any>) {
  if ('detail' in resp) {
    let msg = '';
    (resp.detail as any[]).forEach((element) => {
      msg += `${element.msg}: ${element.loc[1]}. `;
    });
    return msg;
  }
  return mapErrorMsg(resp?.message ?? 'Unexpected error');
}

export function watchErrorToasts(toast: ToastServiceMethods) {
  const { bus } = useEventsBus();

  watch(() => bus.value.get('error'), (val: APIResp<any>) => {
    toast.add({ severity: 'error', summary: 'Грешка', detail: getError(val), life: 5000 });
  }, { deep: true });
}
